import lzw from 'node-lzw';
import safe64 from 'urlsafe-base64';


class JsonUrl {

	constructor() {}

	encode(json) {
		var buffer = Buffer.from(lzw.encode(JSON.stringify(json).toString('utf8')));
		return safe64.encode(buffer);
	}

	decode(string) {
		var buffer = safe64.decode(string);
		return JSON.parse(Buffer.from(lzw.decode(buffer), 'utf8'));
	}

}

export default JsonUrl;



// WEBPACK FOOTER //
// ./src/js/modules/json-url.js